// import React from "react";
// import Section1 from "./Section1";
// import Section2 from "./Section2";
// // import Section4 from "./Section4";
// // import Section3 from "./Section3";
// import Section5 from "./Section5";
// import Footer from "../../common/Footer";
// import Section6 from "./Section6";

// import Navbar from "../../common/Navbar";
// import Section7 from "./Section7";
// // import Section8 from "./Section8";
// import Section9 from "./Section9";
// // import VideoModal from "./VideoModal";
// import Install from "../pwa/install";
// import EcommerceComponent from "./EcommerceComponent";

// function index() {
//   return (
//     <div className="">
//       <Navbar />
//       <Section1 />
//       <EcommerceComponent />
//       <Install />
//       <Section2 />
//       {/* <VideoModal /> */}
//       <Section9 />
//       <Section5 />
//       <Section7 />

//       {/* <Section4/> */}
//       {/* <Section3/> */}
//       {/* <Section8/> */}
//       <Section6 />

//       <Footer />
//     </div>
//   );
// }

// export default index;

import React, { useEffect } from "react";
import Nav from "./Nav";
import Pricing from "./Pricing"
import P4 from "../../assets/banner1.jpg";
import Features from "./features"
import {Link} from "react-router-dom";
import Product from "./product"

const Index = () => {
  return (
    <>
      {/* <Nav /> */}
    
     <div div className="relative isolate px-6 pt-14 lg:px-8">
        <div
          aria-hidden="true"
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
        >
          <div
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#d6bec8] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
          />
        </div>
        <div className="mx-auto max-w-2xl py-32 sm:py-48 lg:py-56">
          <div className="hidden sm:mb-8 sm:flex sm:justify-center">
            <div className="relative rounded-full px-3 py-1 text-sm/6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
              Introducing the new way of Organizing Trips{' '}
              <a href="#" className="font-semibold text-indigo-600">
                <span aria-hidden="true" className="absolute inset-0" />
                Read more <span aria-hidden="true">&rarr;</span>
              </a>
            </div>
          </div>
          <div className="text-center">
            <h1 className="text-balance text-xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
            Drive with TGH
            </h1>
            <p className="mt-8 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
            Empower Your Journey, Maximize Your Earnings
            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <div className="text-center">
    <p className="text-gray-800 mb-2 text-md">Don’t have an account?</p>
              <Link
                to={'/signup'}
                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Create Account
              </Link>
              </div>
            </div>
            <div className="mt-10 flex items-center justify-center gap-x-6">
                <div className="text-center -mt-1">
    <p className="text-gray-800 mb-2 text-md">Already have an account?</p>
              <div className="flex gap-x-4 justify-center">
              <Link
                to={'/signin'}
                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Login with Phone Number
              </Link>
              <Link
                to={'/signpswd'}
                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Login with Password
              </Link> 
              </div>
              </div>
            </div>
          </div>
        </div>
        <div
          aria-hidden="true"
          className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
        >
          <div
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
          />
        </div>
      </div>

      <section id="features">
        <Features/>
      </section>
      
      <section id="product">
     <Product/>
      </section>
    
     
      {/* <section id="pricing">
        <Pricing />
      </section> */}
    </>
  );
};

export default Index;
